import { toast as sonnerToast } from "sonner";
import type { ExternalToast } from "sonner";

// Maintain compatibility with existing code where possible
type ToastProps = ExternalToast & {
  title?: React.ReactNode;
  description?: React.ReactNode;
  variant?: "default" | "destructive" | "success" | "warning" | "info" | "error";
  action?: {
    label: string;
    onClick: () => void;
  };
};

function toast(props: ToastProps | string) {
  if (typeof props === "string") {
    return sonnerToast(props);
  }

  const { title, description, variant, ...rest } = props;

  const options: ExternalToast = { ...rest };
  if (description) {
    options.description = description;
  }

  if (variant === "destructive" || variant === "error") {
    return sonnerToast.error(title || description || "Erreur", options);
  } else if (variant === "success") {
    return sonnerToast.success(title || description || "Succès", options);
  } else if (variant === "info") {
    return sonnerToast.info(title || description || "Info", options);
  } else if (variant === "warning") {
    return sonnerToast.warning(title || description || "Attention", options);
  }

  return sonnerToast(title || description, options);
}

toast.success = (title: React.ReactNode, options?: ExternalToast) =>
  sonnerToast.success(title, options);
toast.error = (title: React.ReactNode, options?: ExternalToast) =>
  sonnerToast.error(title, options);
toast.info = (title: React.ReactNode, options?: ExternalToast) => sonnerToast.info(title, options);
toast.warning = (title: React.ReactNode, options?: ExternalToast) =>
  sonnerToast.warning(title, options);
toast.custom = sonnerToast.custom;
toast.dismiss = sonnerToast.dismiss;

function useToast() {
  return {
    toast,
    dismiss: sonnerToast.dismiss,
  };
}

export { toast, useToast };
